import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = {
  key: 0,
  class: "absolute top-[-40px] left-[-120px] w-[250px]"
}
const _hoisted_3 = { class: "flex flex-col items-center" }
const _hoisted_4 = { class: "p-2 rounded-lg bg-[#393840] text-white text-xs font-medium" }

import {
  getPhaseStatusColor,
  getTerminStatusColor,
  getTerminStatusBorder,
  getPhaseStatusBorder,
} from "@/utils/status-color";
import { ref } from "vue";

type Props = {
  statusId: number;
  statusName: string;
  isTermin: boolean;
};

type Emits = {
  (event: "refresh"): void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'ColoredDot',
  props: {
    statusId: {},
    statusName: {},
    isTermin: { type: Boolean }
  },
  emits: ["refresh"],
  setup(__props: any) {

const props = __props;


const isTooltipOpen = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isTooltipOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(__props.statusName), 1),
            _cache[2] || (_cache[2] = _createElementVNode("svg", {
              width: "10",
              height: "4",
              viewBox: "0 0 10 4",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                d: "M10 0H0L4.37531 3.50024C4.74052 3.79242 5.25948 3.79242 5.62469 3.50024L10 0Z",
                fill: "#393840"
              })
            ], -1))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (isTooltipOpen.value = true)),
      onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (isTooltipOpen.value = false)),
      class: "flex relative"
    }, [
      (__props.isTermin)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "rounded border w-2 h-2",
            style: _normalizeStyle({
          borderColor: `${_unref(getTerminStatusBorder)(__props.statusId)}`,
          backgroundColor: `${_unref(getTerminStatusColor)(__props.statusId)}`,
        })
          }, null, 4))
        : (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "rounded border w-2 h-2",
            style: _normalizeStyle({
          borderColor: `${_unref(getPhaseStatusBorder)(__props.statusId)}`,
          backgroundColor: `${_unref(getPhaseStatusColor)(__props.statusId)}`,
        })
          }, null, 4))
    ], 32)
  ]))
}
}

})